import { EVENT_ALERT_STATUS, LANGUAGE_ALERT_STATUS, MEMBERS_ALERT_STATUS, NOTICE_ALERT_STATUS } from "../constants/adminConstants"

export const setEventAlert = (status) => async(dispatch) => {
    dispatch ({
        type: EVENT_ALERT_STATUS,
        payload: status
    })
}

export const setLanguageAlert = (status) => async(dispatch) => {
    dispatch ({
        type: LANGUAGE_ALERT_STATUS,
        payload: status
    })
}

export const setMembersAlert = (status) => async(dispatch) => {
    dispatch ({
        type: MEMBERS_ALERT_STATUS,
        payload: status
    })
}

export const setNoticeAlert = (status) => async(dispatch) => {
    dispatch ({
        type: NOTICE_ALERT_STATUS,
        payload: status
    })
}